import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'datelocal',
})
export class DateLocalPipe implements PipeTransform {
  transform(value: Date, format: string = ''): string {
    if (value) return moment.utc(value).local().format(format);
    return '';
  }
}
